import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../reducers/Auth/AuthContext';
import { initializeMenu } from '../apis/pdfMenu';
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
} from '@react-pdf/renderer';
import { getAlergensMap } from '../utils/getAlergens';

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Roboto',
    padding: 24,
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  document: {
    width: '90vw',
    height: '90vh',
    margin: '0 auto',
  },
  section: {
    margin: 4,
  },
  sectionCategories: {
    margin: 4,
    flexGrow: 1,
  },
  productsWrapper: {
    paddingBottom: 4,
  },
  sectionProducts: {
    margin: 4,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  sectionProductsName: {
    flexDirection: 'row',
    marginRight: 32,
  },
  sectionProductsPrice: {
    flexDirection: 'row',
  },
  sectionServiceDescription: {
    fontFamily: 'Roboto',
    letterSpacing: -0.05,
    fontSize: 8,
    marginLeft: 2,
    width: '70%',
    fontWeight: 'bold',
  },
  sectionProductsContents: {
    fontFamily: 'Roboto',
    letterSpacing: -0.05,
    fontSize: 8,
    marginLeft: 4,
    width: '70%',
  },
  sectionAlergensContents: {
    fontFamily: 'Roboto',
    letterSpacing: -0.05,
    fontSize: 7,
    marginLeft: 4,
    width: '70%',
  },
  sectionProductsDescription: {
    fontFamily: 'Roboto',
    fontSize: 8,
    marginLeft: 4,
    marginTop: -4,
    width: '70%',
  },
  service: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'bold',
  },
  category: {
    fontSize: 12,
  },
  product: {
    fontFamily: 'Roboto',
    fontSize: 10,
    fontWeight: 'bold',
  },
  image: {
    width: 64,
    height: 32,
  },
  pushDown16: {
    marginBottom: 16,
  },
  pushDown8: {
    marginBottom: 8,
  },
});

const getNutritionText = (values) => {
  return `Valoare Energetică (kJ/kcal): ${String(Math.round(values['ENERGY VALUE'] * 4.184))} / ${values['ENERGY VALUE']}, Grăsimi (g): ${values.FATS} din care: Acizi grași saturați (g) ${values['SATURATED FATS']}, Glucide (g): ${values.CARBOHYDRATES} din care: Zaharuri (g): ${values.SUGARS}, Proteine (g): ${values.PROTEINS}, Sare (g): ${values.SALTS}`;
}

const getNutrition = (product) => {
  const nutrition100g = product?.nutrition?.['100g'] ?? null;
  const nutritionPortion = product?.nutrition?.['portion'] ?? null;

  const text100 = nutrition100g ? getNutritionText(nutrition100g) : null;
  const textPor = nutritionPortion ? getNutritionText(nutritionPortion) : null;
  const additives = product?.nutrition?.additives?.length > 0 ? product.nutrition.additives : null;
  const others = product?.nutrition?.others?.length > 0 ? product.nutrition.others : null;

  return { text100, textPor, additives, others };
}

const availableAlergens = getAlergensMap();

const MyDocument = ({ data }) => {
  const services = Array.isArray(data?.cache?.services?.services)
    ? data.cache.services.services
    : [];

  return (
    <Document title={data?.place?.[0]?.place_id?.toUpperCase() || 'MENU'}>
      {services.map((service) => {
        const categories = Array.isArray(data?.cache?.services?.serviceId__categories?.[service.id])
          ? data.cache.services.serviceId__categories[service.id]
          : [];
        return (
          <Page size="A4" style={styles.page} key={service.id}>
            <View style={styles.section}>
              <Text style={styles.service}>{service?.name?.toUpperCase()}</Text>
              <View>
                {service?.description &&
                  service.description.length > 0 &&
                  service.description !== 'Fara detalii suplimentare' && (
                    <Text style={styles.sectionServiceDescription}>{service.description}</Text>
                  )}
              </View>
              <View style={styles.sectionCategories} key={service.id}>
                {categories.map((category, indexc) => {
                  const products = Array.isArray(
                    data?.cache?.categories?.categoryId__products?.[category.id],
                  )
                    ? data.cache.categories.categoryId__products[category.id]
                    : [];
                  return (
                    <View style={styles.section} key={category.id}>
                      <Text style={styles.category}>{category?.name?.toUpperCase()}</Text>
                      <View style={styles.sectionCategories} key={category.id ?? indexc}>
                        {products.map((product, indexp) => {
                          if (!product || product?.delimiter) {
                            return null;
                          }

                          const nutrition = getNutrition(product);
                          const weight = product?.weight ? product?.weight?.toLowerCase() : null;
                          const nutritionValues = product?.nutrition?.['100g'] ?? {};
                          const productHasNutritionValues = product?.nutrition && Object.keys(nutritionValues).length > 0;

                          const hasAlergens = Array.isArray(product?.alergens) && product.alergens.length > 0;
                        

                          return (
                            <View wrap={false} style={styles.productsWrapper} key={product?.id ?? `p-${indexp}`}>
                              <View style={styles.sectionProducts}>
                                <View style={styles.sectionProductsName}>
                                  {/* {product.imagesXL[0] && (
                                    <Image style={styles.image} src={product.imagesXL[0]} />
                                  )} */}
                                  <Text style={styles.product}>{product.name}</Text>
                                </View>
                                <View style={styles.sectionProductsPrice}>
                                  <Text style={styles.product}>{product.cost}</Text>
                                  <Text style={styles.product}>{product.currency}</Text>
                                </View>
                              </View>
                              <View style={productHasNutritionValues ? styles.pushDown8 : {}}>
                                {product?.details &&
                                  product.details.length > 0 &&
                                  product.details !== 'Fara detalii suplimentare' && (
                                    <Text style={styles.sectionProductsDescription}>
                                      {product.details}
                                    </Text>
                                  )}
                                  {product?.contents &&
                                  product.contents.length > 0 && (
                                    <Text style={styles.sectionProductsContents}>
                                      {`* ${product.contents.join(', ')}`}
                                    </Text>
                                  )}
                              </View>
                              <View style={productHasNutritionValues ? styles.pushDown8 : {}}>
                                {productHasNutritionValues && nutrition && <Text style={styles.sectionProductsContents}>Informatii nutritionale 100g</Text>}
                                {productHasNutritionValues && nutrition && <Text style={styles.sectionAlergensContents}>{nutrition?.text100}</Text>}
                              </View>
                              <View style={productHasNutritionValues ? styles.pushDown8 : {}}>
                                {productHasNutritionValues && nutrition && <Text style={styles.sectionProductsContents}>{weight ? `Informatii nutritionale portie (${weight})` : 'Informatii nutritionale portie'}</Text>}
                                {productHasNutritionValues && nutrition && <Text style={styles.sectionAlergensContents}>{nutrition?.textPor}</Text>}
                              </View>
                              <View style={nutrition?.additives ? styles.pushDown8 : {}}>
                                {nutrition?.additives && <Text style={styles.sectionProductsContents}>Additives</Text>}
                                {nutrition?.additives && <Text style={styles.sectionAlergensContents}>{nutrition.additives}</Text>}
                              </View>
                              <View style={nutrition?.others ? styles.pushDown8 : {}}>
                                {nutrition?.others && <Text style={styles.sectionProductsContents}>Others</Text>}
                                {nutrition?.others && <Text style={styles.sectionAlergensContents}>{nutrition.others}</Text>}
                              </View>
                              <View style={hasAlergens ? styles.pushDown8 : {}}>
                                {hasAlergens && <Text style={styles.sectionProductsContents}>Alergeni</Text>}
                                {hasAlergens && product.alergens.map((alergen, index) => {
                                  return (
                                    <Text key={`${index}-${alergen}`} style={styles.sectionAlergensContents}>
                                      {`* ${availableAlergens[alergen]}`}
                                    </Text>
                                  )
                                })}
                              </View>
                            </View>
                          );
                        })}
                      </View>
                    </View>
                  );
                })}
              </View>
            </View>
          </Page>
        );
      })}
    </Document>
  );
};

const PDFExporter = () => {
  const [authState] = useContext(AuthContext);
  const {
    user: { placeId },
  } = authState;

  const [menu, setMenu] = useState(null); // { place, cache, status }

  const getMenu = async () => {
    const data = await initializeMenu(placeId);
    setMenu(data);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getMenu();
  }, [placeId]);

  if (!menu) {
    return null;
  }

  return (
    <PDFViewer style={styles.document}>
      <MyDocument data={menu} />
    </PDFViewer>
  );
};

export default PDFExporter;
